export const androidAppURL = 'https://play.google.com/store/apps/details?id=com.tiny_doorman&hl=en';
export const iOSAppURL = 'https://itunes.apple.com/us/app/tiny-doorman/id1149478586?mt=8';



/** WEBPACK FOOTER **
 ** ./src/constants.js
 **/